import CreateAccountPage from './CreateAccountPage';
export { CreateAccountPage };
export default CreateAccountPage;
